export enum GfeLogLevel {
  INFO = 'info',
  WARN = 'warn',
  ERROR = 'error'
}

export interface GfeLogPayload {
  gfeVersion: string;
  level: GfeLogLevel;
  data?: unknown;
  url: string;
  metadata?: Record<string, unknown>;
}

export interface QueuedLogEntry extends GfeLogPayload {
  count: number;
  firstOccurrenceAt: string;
  lastOccurrenceAt: string;
}

export interface BulkLogPayload {
  logs: QueuedLogEntry[];
  droppedDistinctSignatures: number;
}
